import * as React from "react";

const FireIcon = (props) => (
  <svg
    viewBox="0 0 31 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      d="M.67 20.481s1.483 2.42 4.592 4.47c0 0-2.251-21.14 12.419-24.811-3.759 15.325 4.78 19.646 7.894 11.55 5.198 7.71 1.251 14.438 1.251 14.438 2.132.34 3.922-2.246 3.922-2.246.016.318.025.64.025.962 0 9.391-6.853 17.005-15.306 17.005C7.013 41.849.16 34.235.16 24.844c0-1.508.177-2.97.51-4.363Z"
      fill="#FF6536"
    />
    <path
      d="M30.748 23.881s-1.79 2.587-3.922 2.246c0 0 3.947-6.727-1.251-14.437-3.113 8.096-11.653 3.774-7.894-11.55-.786.196-1.523.443-2.214.734v40.974c8.453 0 15.306-7.613 15.306-17.004 0-.323-.009-.644-.025-.963Z"
      fill="#FF421D"
    />
    <path
      d="M8.755 34.39c0 4.118 3.005 7.457 6.713 7.457 3.707 0 6.712-3.339 6.712-7.457 0-2.205-.86-4.186-2.23-5.55-2.595 3.916-6.293-2.026-3.411-6.365 0 0-7.784 1.084-7.784 11.915Z"
      fill="#FBBF00"
    />
    <path
      d="M22.18 34.39c0-2.205-.861-4.186-2.23-5.55-2.596 3.916-6.294-2.026-3.412-6.365 0 0-.423.06-1.071.287v19.085c3.707 0 6.713-3.339 6.713-7.457Z"
      fill="#FFA900"
    />
  </svg>
);

export default FireIcon;
